<template>
  <div
    class="loading-element fixed top-0 left-0 z-50 h-screen w-screen flex items-center justify-center transition-all duration-1000 ease-in-out"
  >
    <div
      class="absolute top-0 left-0 z-20 h-full w-full bg-black opacity-80"
    ></div>
    <div v-click-away="closeModal" class="relative z-30 p-10">
      <div class="bg-white p-6">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["closeModal"],
  props: {
    text: String,
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
})
export default class ModalWrapper extends Vue {}
</script>
